import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight, Zap, Smartphone, TrendingUp, CheckCircle, MessageCircle } from "lucide-react";

const CTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const trustItems = [
    "Sem mensalidade",
    "Entrega rápida em até 72h",
    "Páginas pensadas para gerar clientes",
  ];

  const badges = [
    { icon: Zap, label: "Entrega rápida" },
    { icon: Smartphone, label: "100% responsivo" },
    { icon: TrendingUp, label: "Pronto para anúncio" },
  ];

  return (
    <section className="py-24 md:py-32 relative" ref={ref}>
      <div className="absolute inset-0" style={{ background: "var(--gradient-glow)" }} />
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="max-w-2xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-balance">
            Pronto para começar a{" "}
            <span className="gradient-text">gerar clientes</span> pela internet?
          </h2>
          <p className="text-muted-foreground mb-10 text-lg">
            Sua página profissional pronta em até 72 horas. Sem complicação.
          </p>
          <a
            id="btn-cta-principal"
            href="#planos"
            className="group inline-flex items-center gap-2 rounded-xl bg-primary px-10 py-4 text-base font-semibold text-primary-foreground transition-all hover:opacity-90 glow-blue"
          >
            Criar meu site agora
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>

          {/* Trust proof */}
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.3 }}
            className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6"
          >
            {trustItems.map((item, i) => (
              <span key={i} className="flex items-center gap-1.5 text-sm text-muted-foreground">
                <CheckCircle className="w-4 h-4 text-secondary" />
                {item}
              </span>
            ))}
          </motion.div>

          {/* Badges */}
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.5 }}
            className="mt-6 flex flex-wrap items-center justify-center gap-4"
          >
            {badges.map((badge, i) => (
              <div
                key={i}
                className="glass-card flex items-center gap-2 rounded-full px-4 py-2 text-xs font-medium text-foreground"
              >
                <badge.icon className="w-3.5 h-3.5 text-primary" />
                {badge.label}
              </div>
            ))}
          </motion.div>

          {/* Human support */}
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.7 }}
            className="mt-10 glass-card rounded-2xl p-6 flex items-center gap-4 text-left max-w-lg mx-auto"
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 shrink-0">
              <MessageCircle className="w-5 h-5 text-primary" />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">Atendimento rápido e humanizado.</p>
              <p className="text-xs text-muted-foreground mt-1">
                Você fala diretamente com um especialista da nossa equipe para tirar dúvidas e iniciar seu projeto.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
